/* eslint-disable func-names */
/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */

import { WorldMapBackgroundTiles } from './WorldMapBackgroundTiles';
import WorldMapChestDynamicLayer from './G.WorldMapChestDynamicLayer';
import WorldMapGateLayer from './G.WorldMapGateLayer';
import WorldMapBubbleGiftDynamicLayer from './G.WorldMapBubbleGiftDynamicLayer';
import MapTutHand from '../G.MapTutHand';

export default class WorldMap extends Phaser.Group {
    constructor(maptiles, animElements, levels, editorMode, updateQuickPanButtonFunc) {
        super(game);

        setTimeout(function() {
            game.paused = false;
        }, 2000);
        this.signals = {
            onGateOpen: new Phaser.Signal(),
            onMapScrolled: new Phaser.Signal(),
            onAvatarVisibilityChange: new Phaser.Signal(),
        };

        this.activePointer = null;

        this._initCustomInput();

        if (updateQuickPanButtonFunc) {
            this.signals.onAvatarVisibilityChange.add(updateQuickPanButtonFunc);
        }

        this.x = G.l(640) * 0.5;
        this.centerX = G.l(640) * 0.5;
        this.y = game.height;

        this.state = game.state.getCurrentState();
        // added stateInitCount to verify if delayed events happen in the correct scene + initialization
        if (!this.stateInitCount) this.stateInitCount = 0;
        this.stateInitCount++;


        this._bgTiles = new WorldMapBackgroundTiles(this);
        this._btnLayer = new G.WorldMapLvls(this, editorMode);
        this._chestLayer = new WorldMapChestDynamicLayer(this, editorMode);

        const endPoint = G.Helpers.levelDataMgr.getMapPosition(G.Helpers.levelDataMgr.getNumberOfLevels());
        this._lastLvlMsg = new G.WorldMapLastLevel(this, endPoint.x, endPoint.y);

        //this._mapSocialLayer = new G.WorldMapSocialLayer(this, editorMode);
        this._cloudLayer = new G.WorldMapCloudDynamicLayer(this, editorMode);
        this._gateLayer = new WorldMapGateLayer(this, editorMode);
        this._gateLayer.onGateOpen.add((gateId, showTreasureHuntWindow) => {
            this.signals.onGateOpen.dispatch(gateId, showTreasureHuntWindow);
        }, this);
        this._bubbleLayer = new WorldMapBubbleGiftDynamicLayer(this, editorMode);
        this._avatarPlayer = new G.WorldMapPlayerAvatar(this, editorMode);
        this._avatarPlayer.visible = false;

        this.mapTutorialHand = undefined; // Accessing later
        this._addLevelTutorialHand(); // Make hand now for layering
        if (editorMode) this._initEditorMode();

        // configure horizontal scrolling
        if (G.OMTsettings.elements.worldMap && G.OMTsettings.elements.worldMap.allowHScrolling !== null) {
            this._allowHScrolling = G.OMTsettings.elements.worldMap.allowHScrolling;
        } else {
            this._allowHScrolling = true;
        }

        // configure horizontal scrolling
        if (G.OMTsettings.elements.worldMap && G.OMTsettings.elements.worldMap.allowHScrolling !== null) {
            this._allowHScrolling = G.OMTsettings.elements.worldMap.allowHScrolling;
        } else {
            this._allowHScrolling = true;
        }

        console.log(this.width);
        this.mapWidth = this.width * 1.8;
        this.mapHeight = Math.abs(endPoint.y) + 500;
        this.width = this.mapWidth;
        this.height = this.mapHeight;

        this.getLocalBounds();

        this.velX = 0;
        this.velY = 0;
        this._x = G.l(320);
        this._y = this.y;

        this._checkForBotOptIn();

        this._lockedInput = false;

        this.centerOnLvl(Math.min(G.saveState.getLastPassedLevelNr(), G.Helpers.levelDataMgr.getMaxLevelIndex()));

        // MONEY POP UP ANIMATION
        // var lastLevelData = this.state.lastLevelData;
        // this.postLevelFlow(lastLevelData);

        this._previousMapY = null;

        this._canCheckMysteryGiftTimer = false;
        this._mysteryGiftWindowDispatched = false;
        G.Utils.cleanUpOnDestroy(this, G.sb('mysteryGiftWindowDispatched').add(this.toggleMysteryGiftWindowDispatched.bind(this)));

        // set the image smoothing quality to high
        game.canvas.getContext("2d").imageSmoothingQuality = "high";
    }

    async _checkForBotOptIn() {
        const canSubscribe = await OMT.bots.canSubscribeToBot();
        if (canSubscribe === OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.ALREADY) {
            const stateChanged = G.saveState.setBotOptIn(true);

            if (stateChanged) {
                DDNA.tracking.collectEvent('botOptionsChanged', { botSubscribtionStatus: 1, botSubscriptionChangeGameArea: 'Manual' });
                OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptIn);
                OMT.notifications.unscheduleAllGameTriggeredMessages('a2u');
            } else {
                OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotAlreadySubscribed);
            }
            return;
        } else if (canSubscribe === OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.YES) { // eslint-disable-line no-else-return
            const stateChanged = G.saveState.setBotOptIn(false);
            if (stateChanged) {
                DDNA.tracking.collectEvent('botOptionsChanged', { botSubscribtionStatus: 0, botSubscriptionChangeGameArea: 'Manual' });
                OMT.platformTracking.logEvent(OMT.platformTracking.Events.BotOptOut);
                OMT.notifications.unscheduleAllGameTriggeredMessages('bot');
            }
        } else { // canSubscribe == OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.NO user is no longer able to subscribe through the game
            G.saveState.setBotOptIn(false);
            return;
        }

        if (G.saveState.mapChestDataManager.getChestArray().length < 1) {
            G.Helpers.mapChestsMgr.iconAndPopupIn(0, 0);
            return;
        }
        const homeScreenCheck = await OMT.platformFunctions.canCreateShortcutAsync();
        if (!homeScreenCheck) {
            G.Helpers.mapChestsMgr.iconAndPopupIn(0, 3);
            return;
        }
        G.Helpers.bubbleGiftsMgr.iconAndPopupIn(0, 3);
    }

    _initEditorMode() {
        const { levelDataMgr } = G.Helpers;
        this.prevX = null;
        this.prevY = null;

        this._cloudLayer.visible = false;
        this._gateLayer.visible = false;

        const moveToTop = () => {
            this.y = -(levelDataMgr.getLevelByIndex(levelDataMgr.getMaxLevelIndex()).mapY - game.height * 0.5);
        };

        const editorUpdate = () => {
            this.checkPreviousMapPosition();
            this.x = 700;
            if (game.input.activePointer.middleButton.isDown) {
                if (this.prevX !== null) {
                    // this.x -= (this.prevX - game.input.activePointer.x)*3;
                    this.y -= (this.prevY - game.input.activePointer.y) * 3;
                }
                this.prevX = game.input.activePointer.x;
                this.prevY = game.input.activePointer.y;
            } else {
                this.prevX = null;
                this.prevY = null;
            }
        };

        const mouseWheel = (event) => {
            this.y += (event.deltaY / 500) * (event.shiftKey ? 1500 : 300);
        };
        game.input.keyboard.addKey(Phaser.Keyboard.T)
            .onDown.add(moveToTop, this);
        this.update = editorUpdate;
        G.sb('mouseWheelEvent').add(mouseWheel, this);
    }

    _addLevelTutorialHand() {
        const lastPassed = G.saveState.getLastPassedLevelNr();
        if (lastPassed >= 0 && lastPassed <= G.Helpers.levelDataMgr.getMaxLevelIndex()) {
            const tutHandGroup = game.add.group();
            tutHandGroup.position = this.position;
            const tutHand = new MapTutHand(this);
            tutHandGroup.add(tutHand);
            this.mapTutorialHand = tutHand; // Keep reference to MapTutHand
        }
    }

    pointerToInnerPosition(pointer) {
        return {
            x: Math.floor(pointer.worldX - this.worldPosition.x),
            y: Math.floor(pointer.worldY - this.worldPosition.y),
        };
    }

    // Custom input
    _initCustomInput() {
        this.inputLayer = G.makeImage(0, 0, null);

        const dragHandler = G.Input.createCustomInputDragHandler();
        dragHandler.inputDownSignal.add(this.stopDragInertia, this);
        dragHandler.dragUpdateSignal.add(this.startDragging, this);
        dragHandler.dragStopSignal.add(this.stopDragging, this);
        dragHandler.dragCancelSignal.add(this.stopDragging, this);

        G.Input.initializeCustomInput(this.inputLayer);
        this.inputLayer.customInput.addHandler(dragHandler);

        this.inputLayer.hitArea = new Phaser.Rectangle(-10000, -10000, 20000, 20000);
    }

    startDragging(pointer) {
        this.activePointer = pointer;
    }

    stopDragging() {
        this.activePointer = null;
    }

    stopDragInertia() {
        this.velX = 0;
        this.velY = 0;
    }

    async postLevelFlow(lastLevelData) {
        if (lastLevelData &&
            (lastLevelData.starImprovement > 0 || lastLevelData.reward > 0) &&
            !lastLevelData.challenge) {
            this.lockInput();

            // set amount to count up from and update the diplsay
            const coinCounter = { coins: lastLevelData.reward > 0 ? G.saveState.getCoins() - lastLevelData.reward : 0 };
            G.sb('onCoinsChange').dispatch(coinCounter.coins);

            OMT.transactionTracking.logInventoryTransactionBegin();
            OMT.transactionTracking.addInventoryChange('coins', 0, lastLevelData.reward);
            OMT.transactionTracking.logInventoryTransactionEnd();

            // Send bot messages / A2U notifications
            //const levelPassedUser = await this.getLevelPassedPlayer();
            //if (levelPassedUser) {
            //OMT.notifications.scheduleGameTriggeredMessage(levelPassedUser.id, 'PlayerPassed', 1, { level: G.saveState.getLastPassedLevelNr() }, false);
            //}

            game.time.events.add(500, () => {
                this.startBatches(lastLevelData, coinCounter)
                    .then(((async() => {
                        await this._afterBatch();
                    })));
            }, this);
        }
    }

    startBatches(lastLevelData, coinCounter) {
        return new Promise(((resolve, reject) => {
            const batches = [];

            if (lastLevelData.starImprovement > 0) {
                batches.push(this._createBounceParticlesBatch(
                    lastLevelData.lvlNr, lastLevelData.starImprovement, 'stars', coinCounter,
                ));
            }

            if (lastLevelData.reward > 0) {
                batches.push(this._createBounceParticlesBatch(
                    lastLevelData.lvlNr, lastLevelData.reward, 'coins', coinCounter,
                ));
            }

            if (batches.length === 0) {
                resolve();
            } else {
                Promise.all(batches).then(() => {
                    // trigger coin change dispatch and save state change without altering coin total
                    // G.saveState.changeCoins(0, true);
                    G.sb('onCoinsChange').dispatch(G.saveState.getCoins());
                    resolve();
                });
            }
        }));
    }

    centerOnLvl(lvlIndex) {
        const lvlData = G.Helpers.levelDataMgr.getLevelByIndex(lvlIndex);
        if (!lvlData) return;
        const { mapX } = lvlData;
        const { mapY } = lvlData;
        if (this._allowHScrolling) this.x = this._x = 320 - mapX;
        this.y = this._y = game.math.clamp(game.height + (Math.abs(mapY) - game.height * 0.5), game.height, Math.max(game.height, this.mapHeight));
        this._updatePosition();
    }

    scrollToPoint(config, callback, context) {
        const pos = {};
        this.chestScroll = true;
        this.lockInput();
        const diff = Math.max(0, (1200 - game.width) * 0.5);
        if (config.lvlNr) {
            config.lvlNr = Math.min(G.Helpers.levelDataMgr.getMaxLevelIndex(), config.lvlNr);
            const levelData = G.Helpers.levelDataMgr.getLevelByIndex(config.lvlNr);

            if (this._allowHScrolling) {
                pos.x = game.math.clamp(
                    320 - levelData.mapX,
                    320 - diff,
                    320 + diff,
                );
            } else {
                this.x = 320;
            }

            pos.y = game.math.clamp(
                game.height + (Math.abs(levelData.mapY) - game.height * 0.5),
                game.height,
                Math.max(game.height, this.mapHeight),
            );
        } else {
            if (this._allowHScrolling) {
                pos.x = game.math.clamp(320 - config.x,
                    320 - diff,
                    320 + diff);
            } else {
                this.x = 320;
            }

            pos.y = game.math.clamp(
                game.height + (Math.abs(config.y) - game.height * 0.5),
                game.height,
                Math.max(game.height, this.mapHeight),
            );
        }

        const tween = game.add.tween(this)
            .to({
                x: pos.x,
                _x: pos.x,
                y: pos.y,
                _y: pos.y,
            }, 1300, Phaser.Easing.Sinusoidal.InOut, true);

        tween.onComplete.add(function() {
            this.chestScroll = false;
            this.unlockInput();
        }, this);

        if (callback) tween.onComplete.add(callback, context);
    }

    checkPreviousMapPosition() {
        if (this.y !== this._previousMapY) {
            this._previousMapY = this.y;
            this.signals.onMapScrolled.dispatch(this.y);
        }
    }

    checkMysteryGiftTimer() {
        if (!G.MYSTERYGIFT ||
            !G.saveState.data.mysteryGift ||
            !this._canCheckMysteryGiftTimer ||
            this._mysteryGiftWindowDispatched) {
            return;
        }

        if (G.saveState.data.mysteryGift.endOfLastStreak === 0 &&
            G.saveState.mysteryGift_getCurrentStreak() > 0 &&
            G.saveState.mysteryGift_isModeReady() &&
            G.saveState.mysteryGift_getRemainingGiftCooldown() === 0) {
            G.sb('pushWindow').dispatch('mysteryGiftStreakIncrese');
            this._mysteryGiftWindowDispatched = true;
            this._canCheckMysteryGiftTimer = false;
        }
    }

    update() {
        this.checkPreviousMapPosition();

        if (this.chestScroll) return;
        if (this._lockedInput) return;

        if (this.state.windowMgr.children.length > 0) {
            this.velY = 0;
            this.velX = 0;
            return;
        }
        const { activePointer } = this;
        if (activePointer) {
            if (this.prevY != null) {
                this.velY = (activePointer.y - this.prevY);
            }
            this.prevY = activePointer.y;

            if (this.prevX != null) {
                this.velX = (activePointer.x - this.prevX);
            }
            this.prevX = activePointer.x;
        } else {
            this.prevY = null;
            this.prevX = null;
        }
        this._x += this.velX;
        this._y += this.velY;
        this.velX *= 0.95;
        this.velY *= 0.95;
        this._updatePosition();

        if (this._lastLvlMsg) this._lastLvlMsg.update();
        if (this.mapTutorialHand && !this.mapTutorialHand.positionIsSet) this.mapTutorialHand.reposition(); // Calculate hand position here

        // this.checkAndUpdateAvatarVisibilityState(activePointer);
        this.checkMysteryGiftTimer();
    }

    checkAndUpdateAvatarVisibilityState(activePointer) {
        const avatarPlayer = this._avatarPlayer;
        // if pointer is active or the camera is moving above a threshold (but we won't check that if
        // the velocities are both zero
        if (
            activePointer ||
            (
                (Math.abs(this.velX) > 0.009 || Math.abs(this.velY) > 0.009)
            )
        ) {
            const distToPlayerAvatar = (this.y - (avatarPlayer.avatar.y * -1));
            let change = false;
            const { VisibilityStates } = G.WorldMapPlayerAvatar;

            if (
                distToPlayerAvatar >= game.height
            ) {
                if (avatarPlayer.visibilityState !== VisibilityStates.HiddenBelow) {
                    avatarPlayer.visibilityState = VisibilityStates.HiddenBelow;
                    change = true;
                }
            } else if (distToPlayerAvatar <= 0) {
                if (avatarPlayer.visibilityState !== VisibilityStates.HiddenAbove) {
                    avatarPlayer.visibilityState = VisibilityStates.HiddenAbove;
                    change = true;
                }
            } else if (avatarPlayer.visibilityState !== VisibilityStates.Visible) {
                avatarPlayer.visibilityState = VisibilityStates.Visible;
                change = true;
            }

            if (change) {
                this.signals.onAvatarVisibilityChange.dispatch(avatarPlayer.visibilityState);
            }
        }
    }

    goToPositionY(inY) {
        if (this._y !== inY) {
            this._y = inY;
            this._updatePosition();
        }
    }

    _updatePosition() {
        let mapHeight = Math.min(this.mapHeight, this._gateLayer.getMinY() + 500);
        if (this.state.EDITOR) mapHeight = this.mapHeight;

        this._y = game.math.clamp(this._y, game.height, Math.max(game.height, mapHeight));
        this.y = game.math.clamp(Math.round(this._y), game.height, Math.max(game.height, mapHeight));

        if (this._allowHScrolling) { // cook format does not have horizontal scrolling
            const diff = Math.max(0, (1200 - game.width) * 0.5);
            this._x = game.math.clamp(this._x,
                320 - diff,
                320 + diff);
            this.x = Math.ceil(this._x);
        }
    }

    editorRefreshButtons() {
        this._btnLayer.editorRefreshData();
    }

    lockInput() {
        this._lockedInput = true;
        this._btnLayer.ignoreChildInput = true;
        this._chestLayer.lockInput();
        this._gateLayer.lockInput();
    }

    unlockInput() {
        this._lockedInput = false;
        this._btnLayer.ignoreChildInput = false;
        this._chestLayer.unlockInput();
        this._gateLayer.unlockInput();
    }

    goToPlayerAvatar() {
        const distanceAsFloat = (this.y / Math.abs(this._avatarPlayer.avatar.y));

        const inversedPercent = 1 - distanceAsFloat;

        const duration = Math.max(inversedPercent * 9000, 1500);

        this.lockInput();
        const lvlData = G.Helpers.levelDataMgr.getLevelByIndex(G.saveState.getLastPassedLevelNr());
        const { mapX } = lvlData;
        game.add.tween(this).to({
                x: 34 - mapX,
                y: (this._avatarPlayer.avatar.y * -1) + (game.height * 0.5),
            }, duration, Phaser.Easing.Quadratic.InOut, true)
            .onComplete.add(() => {
                this._y = this.y;
                this._x = this.x;
                // this._avatarPlayer.visibilityState = G.WorldMapPlayerAvatar.VisibilityStates.Visible;
                //if (G.OMTsettings.elements.worldMap && G.OMTsettings.elements.worldMap.allowHScrolling !== null)
                //this.centerOnLvl(Math.min(G.saveState.getLastPassedLevelNr(), G.Helpers.levelDataMgr.getMaxLevelIndex()));
                this.unlockInput();
            }, this);
    }

    /**
     * create batch of bounce particles
     * @param {number} lvlNr
     * @param {number} amount
     * @param {string} objType
     * @param {Object} coinCounter
     */
    _createBounceParticlesBatch(lvlNr, amount, objType, coinCounter) {
        const coins = objType === 'coins';
        const btn = this._btnLayer.getButtonObj(lvlNr);
        const state = game.state.getCurrentState();

        const onParticleStart = (particle) => {
            if (coins) particle.scale.setTo(0.75);
            // this.vel.setTo(game.rnd.realInRange(-12,12),game.rnd.realInRange(-12,12));
            particle.speedDelta = 1.5;
            particle.speedMax = 35;

            let verOffsetY = 0;
            let verVelY = G.lnf((Math.random() * -2) - 5);
            let velX = game.rnd.realInRange(-2.5, 2.5);
            let yy = particle.y;
            let velYY = game.rnd.realInRange(-2.5, 2.5);
            let grounded = false;

            const originalUpdateMethod = particle.update;
            const particleCustomUpdate = () => {
                if (grounded) return;
                particle.x += velX;
                yy += velYY;
                verOffsetY += verVelY;

                if (verOffsetY > 0) {
                    if (Math.abs(verVelY) > 4) {
                        verVelY *= -0.7;
                    } else {
                        velX = 0;
                        velYY = 0;
                        grounded = true;
                        game.time.events.add(game.rnd.between(200, 600), () => {
                            particle.update = originalUpdateMethod;
                        });
                    }
                } else {
                    verVelY += 0.5;
                }
                verOffsetY = Math.min(0, verOffsetY);
                particle.y = yy + verOffsetY;
            };
            particle.update = particleCustomUpdate;
        };

        const onParticleFinish = (particle) => {
            if (coins) {
                coinCounter.coins += particle.carriedValue;
                G.sb('onCoinsChange').dispatch(coinCounter.coins);
                G.sfx.coin_collect.play();
            } else {
                const { starsTxt } = state.panel;
                starsTxt.setText(parseInt(starsTxt.text) + 1);
            }
        };

        return new Promise(((resolve, reject) => {
            if (!btn) return resolve();
            const batch = this.state.uiTargetParticlesBW.createDividedBatch(
                game.world.bounds.x + btn.worldPosition.x,
                btn.worldPosition.y,
                coins ? 'coin_1' : 'map_star_1',
                coins ? this.state.panel.coinsTxt : this.state.panel.starsTxt,
                amount,
                coins ? 5 : 1,
            );

            batch.addOnPartStart(onParticleStart);
            batch.addOnPartFinish(onParticleFinish);
            batch.onFinish.addOnce(resolve);

            batch.start();
            return null;
        }));
    }

    async _afterBatch() {
        const { stateInitCount } = this;
        const { levelDataMgr } = G.Helpers;

        const numberOfLevels = levelDataMgr.getNumberOfLevels();

        const pos = G.Helpers.levelDataMgr.getMapPosition(Math.min(
            G.saveState.getLastPassedLevelNr(),
            G.Helpers.levelDataMgr.getMaxLevelIndex(),
        ));
        const closestChest = G.saveState.mapChestDataManager.getClosestUnlockedChest(pos);

        if (closestChest) {
            this.scrollToPoint({ x: closestChest.x, y: closestChest.y });

            G.sb('mapChestWindowClosed').addOnce(() => {
                this.scrollToPoint({
                    lvlNr: G.saveState.getLastPassedLevelNr(),
                });
            });
        } else {
            this.unlockInput();

            if (G.saveState.getLastPassedLevelNr() === numberOfLevels) return;
            if (G.saveState.getLastPassedLevelNr() === G.Helpers.gatesMgr.getFirstClosedGateLvLIndex()) return;

            const closeGiftBubble = G.Helpers.bubbleGiftsMgr.getUnopenedBubblesLevels()
                .find((levelNumber) => levelNumber - 1 === G.saveState.getLastPassedLevelNr());

            if (!closeGiftBubble) {
                const lvlIndex = game.math.clamp(G.saveState.getLastPassedLevelNr(), 0, numberOfLevels - 1);
                const lvlData = G.Helpers.levelDataMgr.getLevelByIndex(lvlIndex);

                // TODO: get rid of those globals
                G.lvlNr = lvlIndex;
                G.lvlData = lvlData;

                // TODO: make these progress events work again
                // these get overwritten by the next level window as well?
                //await this.checkHighscoreProgress();
                //await this.checkLevelProgress();

                const isCorrectScene = game.state.getCurrentState() === this.state && stateInitCount === this.stateInitCount;
                if (isCorrectScene) {
                    this.checkMysteryGiftTimer();
                    if (lvlData) {
                        G.sb('pushWindow').dispatch(['level', lvlIndex], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
                    }
                }
            }
        }

        this._canCheckMysteryGiftTimer = true;
    }

    async checkLevelProgress() {
        const passedUser = await this.getLevelPassedPlayer();
        if (passedUser) G.sb('pushWindow').dispatch(['friendOvertaken', passedUser]);
    }

    async checkHighscoreProgress() {
        const passedUser = await this.getScoreBeatenPlayer();
        if (passedUser) {
            G.sb('pushWindow').dispatch([
                'highscoreBeaten',
                passedUser,
            ]);
        }
    }

    async getLevelPassedPlayer() {
        const { stateInitCount } = this;
        console.log("worldmap firends");
        const friendsList = await OMT.friends.getFriendsList();
        const state = game.state.getCurrentState();
        if (!state.lastLevelData) return null;

        if (state.lastLevelData.lvlNr + 1 === G.saveState.getLastPassedLevelNr() &&
            state.lastLevelData.starImprovement === G.saveState.data.levels[state.lastLevelData.lvlNr]) {
            const levelLeaderboard = friendsList.filter((user) => user.maxLevel);
            const passedUser = levelLeaderboard.find((user) => user.maxLevel === G.saveState.getLastPassedLevelNr());
            const isCorrectScene = game.state.getCurrentState() === this.state && stateInitCount === this.stateInitCount;
            if (passedUser && isCorrectScene) return passedUser;
        }

        return null;
    }

    async getScoreBeatenPlayer() {
        try {
            const { stateInitCount } = this;
            const state = game.state.getCurrentState();
            if (!state.lastLevelData) return null;

            const { globalScoreChange } = state.lastLevelData;
            const globalLeaderboard = await OMT.leaderboards.getLeaderBoardEntries('default', 'default');
            const passedUser = globalLeaderboard.find((user) => user.score > globalScoreChange.old && user.score < globalScoreChange.new && !user.isCurrentUser);

            const isCorrectScene = game.state.getCurrentState() === this.state && stateInitCount === this.stateInitCount;
            if (passedUser && isCorrectScene) return passedUser;
            return null;
        } catch (error) {
            // could not connect to backend
            return null;
        }
    }

    getSingleTileMapHeight() {
        return this._bgTiles.getTotalMapHeight();
    }

    getTileMapWidth() {
        return this._bgTiles.width || 322; // At least FISH's is 322.
    }

    getClosestBubblePositionTo(thisLevel) {
        const targetBubble = this._bubbleLayer.getBubblePositionByLevel(thisLevel);
        return targetBubble;
    }

    toggleMysteryGiftWindowDispatched(res) {
        this._mysteryGiftWindowDispatched = res;
    }
}